import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';
import { ApplicationContext } from '@wix/editor-platform-contexts';
import type {
  IPage,
  AddExtensionOptions,
  AddTemplateOptions,
} from '@wix/public-editor-platform-interfaces';

export class PagesSDKShape extends BaseSDKShape {
  constructor(
    protected overriddenApplicationContext: Promise<ApplicationContext> | null = null,
  ) {
    super(overriddenApplicationContext);
  }

  async list(): Promise<IPage[]> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.pages.list();
  }

  async addTemplate(
    templateId: string,
    options: AddTemplateOptions,
  ): Promise<IPage> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.pages.addTemplate(templateId, options);
  }

  async addExtension(
    extensionId: string,
    options?: AddExtensionOptions,
  ): Promise<IPage> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.pages.addExtension(extensionId, options);
  }
}

export default new PlatformSDKShape(PagesSDKShape)
  .withPublicMethod('list')
  .withPublicMethod('addTemplate')
  .withPublicMethod('addExtension')
  .build();
